/**
 * The view loaded into a circuit for signing documents.
 */
import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { AbstractStepTransactionComponent, StepErrorBuilder, StepErrorUtils, SubscriptionManager } from '@pes/ui';
import { ParcoursLbpaStep } from '../../step/parcours-lbpa.step';
import { finalize } from 'rxjs/operators/finalize';
import { TagCommanderService } from '../../utils/service/tag-commander.service';

@Component({
    selector: 'lbpa-parcours',
    templateUrl: './step-signature-parcours-lbpa.component.html',
    styleUrls: ['./step-signature-parcours-lbpa.component.scss']
})
export class StepSignatureParcoursLbpaComponent extends AbstractStepTransactionComponent implements OnInit, OnDestroy {
    /**
     * The reference to the view name.
     */
    public static readonly VIEW_REF: string = 'StepSignatureParcoursLbpaComponent';
    /**
     * The reference to the step associated with this step view.
     */
    public step: ParcoursLbpaStep = null;
    public showStepCard: boolean = true;
    public welcomeStep: boolean = true
    public validateStep: boolean = false;
    public signStep: boolean = false;

    validateTitle = "templates.workflow02.tasks.signature_subscriber.steps.validate.title";
    signTitle = "templates.workflow02.tasks.signature_subscriber.steps.signature.title";
    welcomeTitle = "lbpa.modals.welcome.title";

    private readonly tagCommanderService: TagCommanderService = null;

    constructor(protected injector: Injector) {
        super(injector, StepSignatureParcoursLbpaComponent.VIEW_REF);
        this.tagCommanderService = this.injector.get(TagCommanderService);
        SubscriptionManager.getInstance().createSubscribable(this);
    }

    public ngOnInit(): void {
        this.tagCommanderService.tagPageSign(this.task.data.context.contractType);
        let documentsCount = 0;
        this.task.data.taskData.transactions.forEach((transaction: any) => {
            documentsCount += transaction.documents.length;
        })
        // S'il n'y a qu'un document on ne display la welcome page que si healthData = true
        if (documentsCount < 2) {
            this.validateTitle = "templates.workflow02.tasks.signature_subscriber.steps.validate.titleOneDocument"
            this.signTitle = "templates.workflow02.tasks.signature_subscriber.steps.signature.titleOneDocument"
            this.welcomeTitle = this.task.data.context.healthData ? "lbpa.modals.welcome.titleSante" : this.welcomeTitle
            this.welcomeStep = this.task.data.context.healthData;
            this.validateStep = !this.task.data.context.healthData;
        }
    }

    public ngOnDestroy(): void {
        SubscriptionManager.getInstance().deleteSubscribable(this);
    }

    public goToValidate(): void {
        this.orchestrator.forceLoading(true);
        this.validateStep = true;
        this.welcomeStep = false;

    }

    public gotToSign(): void {
        this.signStep = true;
        this.validateStep = false;
    }

    public loader(event: boolean): void {
        this.orchestrator.forceLoading(event);
    }

    public notifyError(error: any): void {
        this.orchestrator.notifyError(StepErrorBuilder.build(StepErrorUtils.getErrorMessage(error)));
    }

    public submitTask(data: any): void {
        this.orchestrator.checkValidAndSubmit({
            stepIdx: data.stepIdx,
            taskData: data.taskData
        }).pipe(
            finalize(() => {
                this.orchestrator.forceLoading(false)
            })
        ).subscribe(() => {
            this.showStepCard = false;
            this.stepEventService.doExitStepEvent(this);
            this.orchestrator.goToNext();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/component/step-parcours-lbpa/step-signature-parcours-lbpa.component.ts